
import Axios from 'axios';
import { ApiUtils } from './api-utils';
import { BrsTiers } from '@/model/brs-tiers';
import { Region } from '@/model/region';
import { DateEcheance } from '@/model/dateEcheance';
import { formatInTimeZone } from 'date-fns-tz';

export class TiersApi {
  static getInfosTiers (numtiers : string): Promise<BrsTiers> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/tiers/${numtiers}`), BrsTiers);
  }

  static getInfosUser (): Promise<Region[]> {
    return ApiUtils.responseParser(Axios.get('/web/v1/region-utilisateur'), [Region]);
  }

  static getEcheanceTiers (numtiers : string, codeReglement: string, dateReference: Date): Promise<DateEcheance> {
    return ApiUtils.responseParser(Axios.get(`/web/v1/tiers/${numtiers}/reglement/${codeReglement}?dateReference=${formatInTimeZone(dateReference, 'Europe/Paris', 'yyyy-MM-dd')}`), DateEcheance);
  }
}
